import { Button, TableRow } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { LinkedMoveSlideout, LinkedAction } from "../LinkedMoveSlideout";
import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { RowDispatchControlFields } from "@mcleod/general/src/models/autogen/AutogenModelDispatchControl";

export class RowActionLink extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonLink
    }

    override getButtonId(): string {
        return "buttonLink";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["linked_id", "brokerage", "hold", "tractor", "driver1_id", "driver2_id"];
    }

    override getMaxSelections(): keyof RowDispatchControlFields | number {
        return "max_a_link_selections";
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        if (selectedRows.length < 2) {
            this.addReason(reasonMap, "min_link_moves", "Select at least two rows to link.");
            return;
        }
        if (selectedRows.some(row => !row.isNull("linked_id"))) {
            this.checkForValidLinkedMoves(selectedRows, reasonMap);
        }
        selectedRows.forEach(row => this.rowValidator(reasonMap, row));
    }

    private rowValidator (reasonMap: ReasonMap, modelRow: ModelRow) {
        const arrayField = "order_id";
        if (modelRow.getBoolean("brokerage")) {
            this.addReason(reasonMap, "brokerage", "Cannot link brokered moves for [{0}].", modelRow, arrayField);
        }
        if (modelRow.getBoolean("hold", false)) {
            this.addReason(reasonMap, "hold", "Cannot link a move that is on hold for [{0}].", modelRow, arrayField);
        }
        if (!modelRow.isNull("tractor") || !modelRow.isNull("driver1_id") || !modelRow.isNull("driver2_id")) {
            this.addReason(reasonMap, "assigned", "Cannot link a move that has an assigned tractor or driver for [{0}].", modelRow, arrayField);
        }
    }

    checkForValidLinkedMoves(selectedRows: ModelRow[], reasonMap: ReasonMap): boolean {
        let linkedId = null;
        selectedRows.forEach(row => {
            if (!row.isNull("linked_id")) {
                if (linkedId === null) {
                    linkedId = row.getNumber("linked_id");
                } else if (linkedId !== row.getNumber("linked_id")) {
                    this.addReason(reasonMap, "different_linked", "Selected moves must be part of the same linked group.");
                    return false;
                }
            }
        });
        if (!selectedRows.some(row => row.isNull("linked_id"))) {
            this.addReason(reasonMap, "already_linked", "Selected moves must include at least one unlinked move to add.");
            return false;
        }
        return true;
    }

    override async execute(props: PlanningTableRowActionProps) {
        const selectedRows = props.selectedRows;
        const linkedId = this.findExistingLinkedId(selectedRows);
        new LinkedMoveSlideout({
            selectedRows,
            ...(linkedId != null ? { linkedId } : {}),
            linkedAction: linkedId != null ? LinkedAction.EDIT : LinkedAction.ADD
        });
    }

    findExistingLinkedId(selectedRows: TableRow[]): string | null {
        const linkedRow = selectedRows.find(row => !row.data.isNull("linked_id"));
        return linkedRow ? linkedRow.data.get("linked_id") : null;
    }
}
